import React from "react";
import { Form } from "semantic-ui-react";
import { getSemanticProps } from "../../util";
import TitleField from "../../Fields/TitleField";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";

function selectValue(value: any, selected: any[], all: any[]) {
  const at = all.indexOf(value);
  const updated = selected.slice(0, at).concat(value, selected.slice(at));
  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  //@ts-ignore
  return updated.sort((a, b) => all.indexOf(a) > all.indexOf(b));
}

function deselectValue(value: any, selected: any[]) {
  return selected.filter((v) => v !== value);
}

function CheckboxesWidget({
  id,
  disabled,
  options,
  value,
  autofocus,
  readonly,
  onChange,
  onBlur,
  onFocus,
  formContext,
  schema,
  rawErrors = [],
}: any) {
  const { t } = useSchemaTranslation();

  const { enumOptions, enumDisabled, inline } = options;
  const { title } = schema;
  const semanticProps = getSemanticProps({ formContext, options });
  const _onChange = (option: any) => ({ target: { checked } }: any) => {
    // eslint-disable-next-line no-shadow


    const all = enumOptions.map(({ value }: any) => value);
    if (checked) {
      onChange(selectValue(option.value, value, all));
    } else {
      onChange(deselectValue(option.value, value));
    }
  };

  const _onBlur = () => onBlur && onBlur(id, value);
  const _onFocus = () => onFocus && onFocus(id, value);
  const inlineOption = inline ? { inline: true } : { grouped: true };
  return (
    <React.Fragment>
      {title && <TitleField title={t(title)} />}
      <Form.Group {...inlineOption}>
        {enumOptions.length ? (
          enumOptions.map((option: any, index: number) => {
            const checked = value.indexOf(option.value) !== -1;
            const itemDisabled =
              enumDisabled && enumDisabled.indexOf(option.value) !== -1;
            return (
              <Form.Checkbox
                id={`${id}_${index}`}
                key={`${id}_${index}`}
                label={t(option.label)}
                {...semanticProps}
                checked={checked}
                error={Boolean(rawErrors.length)}
                disabled={disabled || itemDisabled || readonly}
                autoFocus={autofocus && index === 0}
                onChange={_onChange(option)}
                onBlur={_onBlur}
                onFocus={_onFocus}
              />
            );
          })
        ) : (
          <p> No options </p>
        )}
      </Form.Group>
    </React.Fragment>
  );
}

CheckboxesWidget.defaultProps = {
  options: {
    semantic: {
      // inverted: false,
    },
  },
};

export default CheckboxesWidget;
